const ORDER_STATUS_LABELS = [
  { match: (code) => code === "200", label: "Złożone" },
  { match: (code) => code === "300", label: "Realizowane" },
  { match: (code) => code === "400", label: "Wysłane" },
  { match: (code) => Number(code) >= 900, label: "Anulowane" },
];

export const formatExistingOrderMessage = (value) => {
  if (!value) {
    return "";
  }
  const dateObj = new Date(value);
  const label = Number.isNaN(dateObj.getTime())
    ? value
    : dateObj.toLocaleDateString("pl-PL");
  return `Dla wybranego punktu złożono już zamówienie na ${label}.`;
};

export const formatDate = (value) => {
  if (!value) {
    return null;
  }
  if (typeof value === "string") {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      const [, year, month, day] = match;
      return `${day}.${month}.${year}`;
    }
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toLocaleDateString("pl-PL");
};

export const formatCurrency = (value) => {
  if (value === null || value === undefined) {
    return "-";
  }
  const number = Number(value);
  if (Number.isNaN(number)) {
    return "-";
  }
  return `${number.toFixed(2)} zł`;
};

export const formatDateTime = (value) => {
  if (!value) {
    return "-";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "-";
  }
  return date.toLocaleString("pl-PL");
};

export const formatOrderLabel = (order) => {
  if (!order) {
    return "-";
  }
  if (order.httpId) {
    return order.httpId;
  }
  if (order.internalId != null) {
    return `#${order.internalId}`;
  }
  return order.id || "-";
};

export const getOrderStatusLabel = (order) => {
  if (!order?.status) {
    return "Brak statusu";
  }
  const code = order.status.code?.toString?.().trim();
  if (!code) {
    return order.status.name || "Brak statusu";
  }
  const mapping = ORDER_STATUS_LABELS.find((entry) => entry.match(code));
  if (mapping) {
    return mapping.label;
  }
  if (order.status.name) {
    return order.status.name;
  }
  return `Status ${code}`;
};

export const getOrderKey = (order) => {
  const prefix = order?.source || "database";
  const identifier = order?.internalId ?? order?.id;
  return `${prefix}-${identifier}`;
};

export const formatOverdue = (days) => {
  if (days === null || days === undefined) {
    return "0";
  }
  const number = Number(days);
  if (Number.isNaN(number)) {
    return "0";
  }
  return number.toString();
};
